import { render } from "./fugaozhongyi-news.vue?vue&type=template&id=fd0271b8&scoped=true"
import script from "./fugaozhongyi-news.vue?vue&type=script&lang=js"
export * from "./fugaozhongyi-news.vue?vue&type=script&lang=js"

import "./fugaozhongyi-news.vue?vue&type=style&index=0&id=fd0271b8&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0271b8"]])

export default __exports__